import { createAsyncThunk } from '@reduxjs/toolkit';

import { IProgress } from '.';
import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';

const apiDataProvider = new APIDataProvider();

export const getProgressByCurriculum = createAsyncThunk(
  '/progress/get-curriculum',
  async (curriculum: string) => {
    const path = `${ApiPaths.progress}/${curriculum}`;

    const response = await apiDataProvider.get<TApiResponse<IProgress>>(path);

    return response.data;
  }
);

export default getProgressByCurriculum;
